import {Component} from '@angular/core';
import {Store} from '@ngrx/store';
import {map} from 'rxjs/operators';
import {whenLoaded} from '../../../helpers/when-loaded';
import {UntilDestroy} from '@ngneat/until-destroy';
import {BijbAccount} from '../../../models/bijb-account';
import {CurrentAccountSelector} from '../../../ngrx/selectors/current-account-selector';
import {CurrentAccountState} from '../../../ngrx/states/current-account-state';
import { MobileMenuComponent } from '../../shared/mobile-menu/mobile-menu.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';

@UntilDestroy()
@Component({
    selector: 'app-storefront-banner',
    templateUrl: './sf-banner.component.html',
    styleUrls: ['./sf-banner.component.scss'],
    standalone: true,
    imports: [RouterLink, NgIf, FontAwesomeModule, MobileMenuComponent]
})
export class SfBannerComponent {
  public currentAccount: BijbAccount;

  constructor(private currentAccountStateStore: Store<CurrentAccountState>) {
    whenLoaded(this, this.currentAccountStateStore, CurrentAccountSelector)
      .pipe(map(state => state.account))
      .subscribe(acc => {
        this.currentAccount = acc;
      });
  }
}
